package com.sweetlime.bingeamigo

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.sweetlime.bingeamigo.di.initKoin
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Firebase.initialize(
        options = FirebaseOptions(
            apiKey = "AIzaSyDFQlQUDLhx2gIAZ29BJNqvT7eP2Rv7rIE",
            authDomain = "binge-amigo.firebaseapp.com",
            projectId = "binge-amigo",
            storageBucket = "binge-amigo.firebasestorage.app",
            gcmSenderId = "851032075503",
            applicationId = "1:851032075503:web:c29889d06dceb768a23f1a"
        )
    )
    initKoin()
    ComposeViewport {
        App()
    }
}